<template>
  <div id="app" class="app" :class="{'has-bottom-padding' : $route.name !== 'Login'}">
    <Header v-if="!$route.meta.hideHeader" />
    <main id="main" role="main" 
      :class="{
        'login-page' : $route.name == 'Login',
        'content-wrapper' : $route.name != 'Login',
        'document-page' : $route.name == 'Document',
        'header-large' : showFilters || showSearch
      }
    ">
      <router-view />
    </main>
    <Footer v-if="!$route.meta.hideFooter" />
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import Header from '@/components/site-structure/HeaderComponent.vue'
import Footer from '@/components/site-structure/FooterComponent.vue'
export default {
  components: {
    Header,
    Footer
  },

  async mounted() {
    console.log(`App version: ${process.env.VUE_APP_VERSION}`)
    // get bookmarks
    await this.getBookmarksFromLocalStorage()
    await this.getHandshake()
  },

  computed: {
    ...mapGetters({
      headerMarginTop: 'AppStore/getHeaderMarginTop',
      showSearch: 'AppStore/getShowSearch',
      showFilters: 'AppStore/getShowFilters'
    })
  }, 

  methods: {
    ...mapActions({
      setBookmarks: 'DocumentStore/setBookmarks',
      getHandshake: 'UserStore/handshake'
    }),

    async getBookmarksFromLocalStorage() {
			const bookmarks = localStorage.getItem('bookmarks')

			if(bookmarks) {
				const parsedBookmarks = JSON.parse(bookmarks)
				
				// set this array in the document store
				this.setBookmarks(parsedBookmarks)
			}
		}
  }
}
</script>
